import { GenericPipelineParameterMappingSource } from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { ParameterSourceDescriptor } from '../store/processingPipelineJobs.types';

function usePipelineTemplateParameterSourceDescriptors(): Record<
  GenericPipelineParameterMappingSource,
  ParameterSourceDescriptor
> {
  const { t } = useTranslation('app');
  const sourceOptions: ParameterSourceDescriptor[] = [
    {
      sourceId: GenericPipelineParameterMappingSource.CONSTANT,
      title: t`CONSTANT`,
      showValueEditor: true,
    },
    {
      sourceId: GenericPipelineParameterMappingSource.ARRAY_MAPPING,
      title: t`ARRAY_MAPPING`,
      showValueEditor: true,
    },
    {
      sourceId:
        GenericPipelineParameterMappingSource.TRIGGERING_EVENT_IMPORT_JOB_ID,
      title: t`TRIGGERING_EVENT_IMPORT_JOB_ID`,
    },
    {
      sourceId:
        GenericPipelineParameterMappingSource.TRIGGERING_EVENT_IMPORT_JOB_KEY,
      title: t`TRIGGERING_EVENT_IMPORT_JOB_KEY`,
    },
    {
      sourceId:
        GenericPipelineParameterMappingSource.TRIGGERING_EVENT_OBJECT_CREATED,
      title: t`TRIGGERING_EVENT_OBJECT_CREATED`,
    },
    {
      sourceId:
        GenericPipelineParameterMappingSource.TRIGGERING_EVENT_OBJECT_ID,
      title: t`TRIGGERING_EVENT_OBJECT_ID`,
    },
    {
      sourceId:
        GenericPipelineParameterMappingSource.TRIGGERING_EVENT_OBJECT_TYPE,
      title: t`TRIGGERING_EVENT_OBJECT_TYPE`,
    },
    {
      sourceId:
        GenericPipelineParameterMappingSource.TRIGGERING_EVENT_WAREHOUSE_ID,
      title: t`TRIGGERING_EVENT_WAREHOUSE_ID`,
    },
    {
      sourceId: GenericPipelineParameterMappingSource.USER_ID,
      title: t`USER_ID`,
    },
  ];

  const sourceOptionsMap = _.keyBy(sourceOptions, 'sourceId') as Record<
    GenericPipelineParameterMappingSource,
    ParameterSourceDescriptor
  >;
  return sourceOptionsMap;
}

export default usePipelineTemplateParameterSourceDescriptors;
